import styled from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';

export const BodyTr = styled.tr`
  text-decoration: none;
  height: 54px;
  border-bottom: ${props =>
    props.hasDownloadData ? 'none' : `1px solid ${ColorSF2.mediumGray}`};
`;
export const HeaderTr = styled(BodyTr)`
  height: 27px;
  font-size: 12px;
`;
export const Lists = styled.div`
  height: 100%;
  flex: 1 1 0%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;
export const HeaderTableWrapper = styled.div`
  height: 28px;
  margin-right: 8px;
  border-bottom: 1px solid ${ColorSF2.mediumGray};
`;
export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0px;
  table-layout: fixed;
  height: 100%;
`;
export const Thead = styled.thead`
  background-color: ${ColorSF2.paleBlue};
`;
export const TableWrapper = styled.div`
  height: calc(100% - 28px);
  overflow-x: hidden;
  overflow-y: auto;
`;
export const Tbody = styled.tbody`
  background-color: ${ColorSF2.white};
  flex-direction: column;
`;
export const ThColumn = styled.th`
  height: 27px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: left;
  padding-left: 8px;
  width: ${({ width }) => width};
`;
export const TdColumn = styled.td`
  position: relative;
  height: 54px;
  font-size: 0.9rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: left;
  padding: 8px;
  width: ${({ width }) => width};
  @media (max-width: 830px), (max-height: 530px) {
    height: 36px;
    font-size: 12px;
  }
`;
export const MediaIcon = styled.img`
  cursor: pointer;
  height: 35px;
`;
export const ALink = styled.a`
  color: ${ColorSF2.navyBlue};
  &:hover {
    opacity: 0.5;
  }
  border-bottom: 1px solid;
`;
export const StyledBodyTr = styled(BodyTr)`
  background-color: ${ColorSF2.whisperGray};
`;
export const StyledRowDiv = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0 30px;
`;
export const StyledItemDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 5px;
  background-color: ${ColorSF2.silverGray};
`;
export const StyledImageDiv = styled.div`
  position: relative;
  height: 120px;
  min-height: 120px;
  width: 120px;
  min-width: 120px;
  margin: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${ColorSF2.black};
`;
export const StyledTextDiv = styled.div`
  width: 100%;
`;
export const StyledP = styled.p`
  font-size: 10px;
  font-weight: normal;
  margin-left: 10px;
  margin-bottom: 1px;
`;
const basePlayCircleStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  zIndex: 900,
};
export const smallPlayCircleStyle = {
  ...basePlayCircleStyle,
  width: 15,
  height: 15,
};
export const largePlayCircleStyle = {
  ...basePlayCircleStyle,
  width: 35,
  height: 35,
};
export const MediaContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;
